<template>
  <div class="data-grid-function-menu"
       v-if="gridData.config"
       :class="{'precise-mode': isPreciseMode}">
    <span class="precise-mode-header hidden-xs-only"
          v-show="isPreciseMode">
      <span class="precise-mode-detail">
        已选择 <span class="current">{{selectAll ? gridData.totalCount : selection.length}}</span> / {{gridData.totalCount}} 条数据
        <el-button class="select-all" :class="{'quit-select-all': selectAll}" type="text" v-if="allowSelectAll" @click="toggleSelectAll">{{selectAll ? '取消全部选择' : '选择全部数据'}}</el-button>
      </span>
    </span>
    <span class="function-menu-wrap">
      <el-button class="grid-menu-item"
                 type="text"
                 v-if="gridData.config.isShowBack"
                 v-show="!isPreciseMode || selection.length === 0"
                 @click="handleBack">
        <i class="iconfont icon-double-left"></i><span class="text-span">{{gridData.config.backBtnText || '后退'}}</span>
      </el-button>
      <el-button class="grid-menu-item"
                 type="primary"
                 v-if="gridData.config.isCanAdd"
                 v-show="!isPreciseMode || selection.length === 0"
                 @click="handleAddData">
        <i class="iconfont icon-add"></i><span class="text-span">{{gridData.config.addBtnText || '添加'}}</span>
      </el-button>
      <el-button class="grid-menu-item"
                 :disabled="selection.length <= 0"
                 v-if="gridData.config.isCanDelete"
                 @click="handleDeleteData">
        <i class="iconfont icon-delete"></i><span class="text-span">{{gridData.config.deleteBtnText || '删除'}}</span>
      </el-button>
      <template v-if="gridData.config.menus">
        <template v-for="(menu, index) in gridData.config.menus">
          <template v-if="menu.menuAction">
            <template v-if="menu.menuAction.menuActionList && menu.menuAction.menuActionList.length > 0">
              <el-button-group v-if="menu.menuAction.handlerType"
                               v-show="!isPreciseMode || isMenuEnable(menu.menuAction)"
                               class="grid-menu-item"
                               :key="'grid_menu_' + index">
                <el-button class="grid-menu-item"
                           :class="menu.style === 'TEXT' ? 'grid-menu-' + menu.themeType : ''"
                           :type="menu.style === 'TEXT' ? 'text' : menu.themeType || 'primary'"
                           :plain="menu.style === 'BUTTON'"
                           :disabled="!isMenuEnable(menu.menuAction)"
                           @click="handleMenuClick(menu.menuAction)">
                  <i :class="getMenuActionIcon(menu.menuAction)"></i><span class="text-span">{{menu.menuAction.name}}</span>
                </el-button>
                <el-dropdown placement="bottom-end">
                  <div class="el-button-group">
                    <el-button v-show="false"></el-button>
                    <el-button class="dropdown-caret-button"
                               :class="menu.style === 'TEXT' ? 'grid-menu-' + menu.themeType : ''"
                               :type="menu.style === 'TEXT' ? 'text' : menu.themeType || 'primary'"
                               :plain="menu.style === 'BUTTON'">
                      <i class="el-dropdown__icon el-icon-arrow-down"></i>
                    </el-button>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item class="grid-menu-dropdown-item"
                                      :class="'dropdown-item-' + menu.themeType"
                                      v-for="(menuAction, index) in menu.menuAction.menuActionList"
                                      :key="'menu_action_' + index"
                                      @click.native="handleMenuClick(menuAction)"
                                      :disabled="!isMenuEnable(menuAction)">
                      <i :class="getMenuActionIcon(menuAction)"></i>
                      <span class="text-span">{{menuAction.name}}</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-button-group>
              <el-dropdown v-else
                           class="grid-menu-item"
                           placement="bottom"
                           :key="'grid_menu_' + index">
                <el-button class="grid-menu-item"
                           :class="menu.style === 'TEXT' ? 'grid-menu-' + menu.themeType : ''"
                           :type="menu.style === 'TEXT' ? 'text' : menu.themeType || 'primary'"
                           :plain="menu.style === 'BUTTON'"
                           :disabled="!isMenuEnable(menu.menuAction)"
                           @click="handleMenuClick(menu.menuAction)">
                  <i :class="getMenuActionIcon(menu.menuAction)"></i><span class="text-span">{{menu.menuAction.name}}</span><i class="el-dropdown__icon el-icon-arrow-down"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="grid-menu-dropdown-item"
                                    :class="'dropdown-item-' + menu.themeType"
                                    v-for="(menuAction, index) in menu.menuAction.menuActionList"
                                    :key="'menu_action_' + index"
                                    @click.native="handleMenuClick(menuAction)"
                                    :disabled="!isMenuEnable(menuAction)">
                    <i :class="getMenuActionIcon(menuAction)"></i>
                    <span class="text-span">{{menuAction.name}}</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template v-else>
              <DataGridBubble v-if="menu.menuAction.handlerType === 'BUBBLE'"
                              :key="'grid_menu_' + index"
                              :class="menu.menuAction.dimension ? 'dimension--' + menu.menuAction.dimension.type : ''"
                              :visible.sync="menu.menuAction.isShowBubble"
                              :decorator="menu.menuAction.decorator"
                              v-bind="$extend({
                                placement: 'bottom'
                              }, menu.menuAction.extraAttrs)">
                <el-button slot="reference"
                           class="grid-menu-item"
                           :class="menu.style === 'TEXT' ? 'grid-menu-' + menu.themeType : ''"
                           :type="menu.style === 'TEXT' ? 'text' : menu.themeType || 'primary'"
                           :plain="menu.style === 'BUTTON'"
                           :disabled="!isMenuEnable(menu.menuAction)"
                           @click.stop="handleMenuClick(menu.menuAction)"
                           v-show="!isPreciseMode || isMenuEnable(menu.menuAction)">
                  <i :class="getMenuActionIcon(menu.menuAction)"></i><span class="text-span">{{menu.menuAction.name}}</span>
                </el-button>
                <template slot-scope="scope">
                  <DataGridPopover :component-path="menu.menuAction.actionPath"
                                   :visible="menu.menuAction.isShowBubble"
                                   :grid-data="gridData"
                                   :extra-key="menu.menuAction.extraKey"
                                   :extra-id="selection"
                                   :extra-value="selection"
                                   :extra-params="menu.menuAction.extraParams"
                                   :pre-handle-params="() => getPreHandleParams(menu.menuAction)"
                                   :popover-extra="scope"
                                   v-bind="$attrs"
                                   @reloadGridData="reloadGridData"
                                   @hidePopover="hideBubble(menu.menuAction)"
                                   @hidePopoverAndRefresh="hideBubbleAndRefresh(menu.menuAction)"
                                   @hideBubble="hideBubble(menu.menuAction)"
                                   @hideBubbleAndRefresh="hideBubbleAndRefresh(menu.menuAction)"></DataGridPopover>
                </template>
              </DataGridBubble>
              <Tile v-else-if="menu.menuAction.handlerType === 'CUSTOM'"
                    :key="'grid_menu_' + index"
                    :class="menu.menuAction.dimension ? 'dimension--' + menu.menuAction.dimension.type : ''"
                    :component-path="menu.menuAction.actionPath"
                    :menu-name="menu.menuAction.name"
                    :grid-data="gridData"
                    :extra-key="menu.menuAction.extraKey"
                    :extra-id="selection"
                    :extra-value="selection"
                    :extra-params="menu.menuAction.extraParams"
                    :extra-attrs="menu.menuAction.extraAttrs"
                    :pre-handle-params="() => getPreHandleParams(menu.menuAction)"
                    v-bind="$attrs"
                    @reloadGridData="reloadGridData"
                    v-show="!isPreciseMode || isMenuEnable(menu.menuAction)"></Tile>
              <el-button class="grid-menu-item"
                         :key="'grid_menu_' + index"
                         :class="menu.style === 'TEXT' ? 'grid-menu-' + menu.themeType : ''"
                         :type="menu.style === 'TEXT' ? 'text' : menu.themeType || 'primary'"
                         :plain="menu.style === 'BUTTON'"
                         :disabled="!isMenuEnable(menu.menuAction)"
                         @click="handleMenuClick(menu.menuAction)"
                         v-else
                         v-show="!isPreciseMode || isMenuEnable(menu.menuAction)">
                <i :class="getMenuActionIcon(menu.menuAction)"></i><span class="text-span">{{menu.menuAction.name}}</span>
              </el-button>
            </template>
          </template>
        </template>
      </template>
    </span>
    <span class="precise-mode-tail"
          v-show="isPreciseMode">
      <span class="precise-mode-detail hidden-sm-and-up">
        已选择 <span class="current">{{selectAll ? gridData.totalCount : selection.length}}</span> / {{gridData.totalCount}} 条数据
        <el-button class="select-all" :class="{'quit-select-all': selectAll}" type="text" v-if="allowSelectAll" @click="toggleSelectAll">{{selectAll ? '取消全部选择' : '选择全部数据'}}</el-button>
      </span>
      <el-button class="grid-menu-default mode-cancel"
                 type="text"
                 v-if="isPreciseMode"
                 @click="clearSelection">
        <i class="iconfont icon-cancel"></i>
        <span class="text-span">取消选择</span>
      </el-button>
      <el-button class="grid-menu-default data-print" type="text" @click="handlePrintData">
        <i class="iconfont icon-dayin"></i>
        <span class="text-span">打印</span>
      </el-button>
      <el-button class="grid-menu-default data-export" type="text"
                 v-if="gridData.config.exportConfig && gridData.config.exportConfig.length > 0" @click="handleExportData">
        <i class="iconfont icon-daochu"></i>
        <span class="text-span">导出</span>
      </el-button>
    </span>
    <action-form ref="gridLinkForm"
                 class="grid-link-form"
                 :action="submitFormOption.action"
                 :method="submitFormOption.method"
                 :target="submitFormOption.target">
      <template v-if="submitFormOption.postParams">
        <template v-for="(value, key) in submitFormOption.postParams">
          <template v-if="Array.isArray(value)">
            <input v-for="(val, index) in value"
                   :key="'post-param-' + key + '-' + index"
                   type="hidden"
                   :name="key"
                   :value="val"/>
          </template>
          <input v-else
                 :key="'post-param-' + key"
                 type="hidden"
                 :name="key"
                 :value="value"/>
        </template>
      </template>
      <el-button native-type="submit"/>
    </action-form>
    <el-dialog
      v-if="gridData.config.isCanAdd && addDataDialog.isRender"
      v-el-drag-dialog
      :title="gridData.config.title + ' - 添加数据'"
      width="640px"
      custom-class="grid-add-data-dialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      @closed="resetForm('gridAddDataForm')"
      :visible.sync="addDataDialog.isShow">
      <el-form ref="gridAddDataForm"
               :model="addDataDialog.form"
               label-width="100px"
               size="mini"
               v-loading="isLoadingAdd || addDataDialog.isCommitting"
               :element-loading-text="isLoadingAdd ? '数据加载中，请稍等...' : (addDataDialog.isCommitting ? '数据提交中，请稍等...' : '')">
        <div v-for="(column, index) in gridAddableColumns"
             :key="'grid-add-data-' + index">
          <template v-if="column.columnEditor">
            <el-form-item :label="column.name"
                          :prop="column._prop"
                          :rules="getFormItemAddRule(column)">
              <DataGridColumnEditor v-model="addDataDialog.form[column._prop]"
                                    :is-loading.sync="column.isLoadingAdd"
                                    :form-data="addDataDialog.form"
                                    :column-editor="column.columnEditor"
                                    v-bind="$attrs"></DataGridColumnEditor>
              <div v-if="column.inputTip"
                   class="input-tip">{{column.inputTip}}</div>
            </el-form-item>
          </template>
          <template v-else-if="column.inputConfig">
            <template v-if="column.inputConfig.elementType === 'IMAGE_UPLOAD'">
              <el-form-item :label="column.name"
                            :prop="column._prop"
                            :rules="getFormItemAddRule(column, true)">
                <DataGridImageUpload v-model="addDataDialog.form[column._prop]"
                                     :filename.sync="addDataDialog.form[column._prop + '_filename']"
                                     :accept-type="column.inputConfig ? column.inputConfig.acceptType : null"
                                     :max-file-size="column.maxFileSize"
                                     :column="column"
                                     v-bind="$attrs">
                </DataGridImageUpload>
                <div v-if="column.inputTip"
                     class="input-tip">{{column.inputTip}}</div>
              </el-form-item>
            </template>
            <template v-else-if="column.inputConfig.elementType === 'FILE_UPLOAD'">
              <el-form-item :label="column.name"
                            :prop="column._prop"
                            :rules="getFormItemAddRule(column, true)">
                <DataGridFileUpload v-model="addDataDialog.form[column._prop]"
                                    :filename.sync="addDataDialog.form[column._prop + '_filename']"
                                    :accept-type="column.inputConfig ? column.inputConfig.acceptType : null"
                                    :max-file-size="column.maxFileSize"
                                    :column="column"
                                    v-bind="$attrs">
                </DataGridFileUpload>
                <div v-if="column.inputTip"
                     class="input-tip">{{column.inputTip}}</div>
              </el-form-item>
            </template>
            <el-form-item :label="column.name"
                          :prop="column._prop"
                          :rules="getFormItemAddRule(column)"
                          v-else>
              <template v-if="column.inputConfig.elementType === 'DATE_FIELD'">
                <el-date-picker v-model="addDataDialog.form[column._prop]"
                                type="date"
                                prefix-icon="el-icon-date"
                                value-format="yyyy-MM-dd"
                                :placeholder="column.name"
                                style="width: 100%">
                </el-date-picker>
              </template>
              <template v-else-if="column.inputConfig.elementType === 'TIME_FIELD'">
                <el-time-picker v-model="addDataDialog.form[column._prop]"
                                :placeholder="column.name"
                                prefix-icon="el-icon-time"
                                format="HH:mm"
                                value-format="HH:mm"
                                style="width: 100%">
                </el-time-picker>
              </template>
              <template v-else-if="column.inputConfig.elementType === 'DATETIME_FIELD'">
                <el-date-picker v-model="addDataDialog.form[column._prop]"
                                type="datetime"
                                prefix-icon="el-icon-date"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :placeholder="column.name"
                                style="width: 100%">
                </el-date-picker>
              </template>
              <template v-else-if="column.inputConfig.elementType === 'TIME_DETAIL_FIELD'">
                <el-time-picker v-model="addDataDialog.form[column._prop]"
                                :placeholder="column.name"
                                prefix-icon="el-icon-time"
                                value-format="HH:mm:ss"
                                style="width: 100%">
                </el-time-picker>
              </template>
              <template v-else-if="column.inputConfig.elementType === 'CUSTOM_DATE_FIELD'">
                <el-date-picker v-if="column.inputConfig.inputType"
                                v-model="addDataDialog.form[column._prop]"
                                :type="column.inputConfig.inputType.type"
                                prefix-icon="el-icon-date"
                                :format="column.inputConfig.inputType.format"
                                :value-format="column.inputConfig.inputType.valueFormat"
                                :placeholder="column.name"
                                style="width: 100%">
                </el-date-picker>
              </template>
              <template v-else-if="column.inputConfig.elementType === 'DROP_DOWN_SELECT_LIST'">
                <DataGridDataSelect v-model="addDataDialog.form[column._prop]"
                                    :column="column"
                                    :label-prop="column.inputConfig.apiData.valueProp"
                                    :value-prop="column.inputConfig.apiData.keyProp"
                                    :multi-prop="column.inputConfig.apiData.multiProp"
                                    v-bind="$attrs">
                </DataGridDataSelect>
              </template>
              <template v-else-if="column.inputConfig.elementType === 'DROP_DOWN_SELECT_PAGE'">
                <DataGridDataSelect v-model="addDataDialog.form[column._prop]"
                                    :column="column"
                                    :label-prop="column.inputConfig.apiData.valueProp"
                                    :value-prop="column.inputConfig.apiData.keyProp"
                                    :multi-prop="column.inputConfig.apiData.multiProp"
                                    :pageable="true"
                                    v-bind="$attrs">
                </DataGridDataSelect>
              </template>
              <template v-else-if="column.inputConfig.elementType === 'CASCADER_SELECT'">
                <DataGridDataCascader v-model="addDataDialog.form[column._prop]"
                                      :column="column"
                                      :label-prop="column.inputConfig.apiData.labelProp"
                                      :value-prop="column.inputConfig.apiData.valueProp"
                                      :children-prop="column.inputConfig.apiData.childrenProp"
                                      v-bind="$attrs">
                </DataGridDataCascader>
              </template>
              <template v-else-if="column.inputConfig.elementType === 'PASSWORD_FIELD'">
                <PasswordField v-model="addDataDialog.form[column._prop]"
                               :maxlength="column.maxLength > 0 ? column.maxLength : null"
                               :placeholder="column.name"
                               style="width: 100%"></PasswordField>
              </template>
              <template v-else-if="column.inputConfig.elementType === 'TEXTAREA'">
                <el-input v-model="addDataDialog.form[column._prop]"
                          type="textarea"
                          :maxlength="column.maxLength > 0 ? column.maxLength : null"
                          :placeholder="column.name"
                          style="width: 100%"></el-input>
              </template>
              <template v-else-if="column.inputConfig.elementType === 'RICH_EDITOR'">
                <AmEditor v-model="addDataDialog.form[column._prop]"
                          :placeholder="column.name"></AmEditor>
              </template>
              <template v-else-if="column.inputConfig.acceptType">
                <template v-if="column.inputConfig.acceptType.type === 'NUMBER'">
                  <template v-if="column.renderCell && column.renderCell.cellType && column.renderCell.cellType.type === 'rate' && column.renderCell.cellType.cell">
                    <el-rate v-model="addDataDialog.form[column._prop]"
                             :max="column.renderCell.cellType.cell.maxValue"
                             show-score
                             allow-half></el-rate>
                  </template>
                  <el-input v-model="addDataDialog.form[column._prop]"
                            type="number"
                            :maxlength="column.maxLength > 0 ? column.maxLength : null"
                            :placeholder="column.name"
                            v-else
                            style="width: 100%"></el-input>
                </template>
                <el-input v-model="addDataDialog.form[column._prop]"
                          :maxlength="column.maxLength > 0 ? column.maxLength : null"
                          :placeholder="column.name"
                          v-else
                          style="width: 100%"></el-input>
              </template>
              <template v-else>
                <el-input v-model="addDataDialog.form[column._prop]"
                          :maxlength="column.maxLength > 0 ? column.maxLength : null"
                          :placeholder="column.name"
                          style="width: 100%"></el-input>
              </template>
              <div v-if="column.inputTip"
                   class="input-tip">{{column.inputTip}}</div>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item :label="column.name"
                          :prop="column._prop"
                          :rules="getFormItemAddRule(column)">
              <template v-if="column.renderCell && column.renderCell.cellType && column.renderCell.cellType.type === 'switch' && column.renderCell.cellType.cell">
                <el-switch v-model="addDataDialog.form[column._prop]"
                           :active-value="column.renderCell.cellType.cell.activeValue"
                           :inactive-value="column.renderCell.cellType.cell.inactiveValue || false"></el-switch>
              </template>
              <el-input v-model="addDataDialog.form[column._prop]"
                        :maxlength="column.maxLength > 0 ? column.maxLength : null"
                        :placeholder="column.name"
                        v-else
                        style="width: 100%"></el-input>
              <div v-if="column.inputTip"
                   class="input-tip">{{column.inputTip}}</div>
            </el-form-item>
          </template>
        </div>
      </el-form>
      <span slot="footer">
        <el-button type="primary" size="mini" :disabled="isLoadingAdd || addDataDialog.isCommitting" @click="submitAddData">提交保存</el-button>
        <el-button size="mini" @click="addDataDialog.isShow = false">关闭窗口</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-if="gridData.config.isCanUpdate && updateDataDialog.isRender"
      v-el-drag-dialog
      :title="gridData.config.title + ' - 更新数据'"
      width="640px"
      custom-class="grid-update-data-dialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      @closed="resetForm('gridUpdateDataForm')"
      :visible.sync="updateDataDialog.isShow">
      <el-form ref="gridUpdateDataForm"
               :model="updateDataDialog.form"
               label-width="100px"
               size="mini"
               v-loading="isLoadingUpdate || updateDataDialog.isCommitting"
               :element-loading-text="isLoadingUpdate ? '数据加载中，请稍等...' : (updateDataDialog.isCommitting ? '数据提交中，请稍等...' : '')">
        <div v-for="(column, index) in gridUpdatableColumns"
             :key="'grid-update-data-' + index">
          <template v-if="column.columnEditor">
            <el-form-item :label="column.name"
                          :prop="column._prop"
                          :rules="getFormItemUpdateRule(column)">
              <DataGridColumnEditor v-model="updateDataDialog.form[column._prop]"
                                    :is-loading.sync="column.isLoadingUpdate"
                                    :is-update="true"
                                    :form-data="updateDataDialog.form"
                                    :column-editor="column.columnEditor"
                                    v-bind="$attrs"></DataGridColumnEditor>
              <div v-if="column.inputTip"
                   class="input-tip">{{column.inputTip}}</div>
            </el-form-item>
          </template>
          <template v-else-if="column.inputConfig">
            <template v-if="column.inputConfig.elementType === 'IMAGE_UPLOAD'">
              <el-form-item :label="column.name"
                            :prop="column._prop"
                            :rules="getFormItemUpdateRule(column, true)">
                <DataGridImageUpload v-model="updateDataDialog.form[column._prop]"
                                     :filename.sync="updateDataDialog.form[column._prop + '_filename']"
                                     :accept-type="column.inputConfig ? column.inputConfig.acceptType : null"
                                     :max-file-size="column.maxFileSize"
                                     :column="column"
                                     v-bind="$attrs">
                </DataGridImageUpload>
                <div v-if="column.inputTip"
                     class="input-tip">{{column.inputTip}}</div>
              </el-form-item>
            </template>
            <template v-else-if="column.inputConfig.elementType === 'FILE_UPLOAD'">
              <el-form-item :label="column.name"
                            :prop="column._prop"
                            :rules="getFormItemUpdateRule(column, true)">
                <DataGridFileUpload v-model="updateDataDialog.form[column._prop]"
                                    :filename.sync="updateDataDialog.form[column._prop + '_filename']"
                                    :accept-type="column.inputConfig ? column.inputConfig.acceptType : null"
                                    :max-file-size="column.maxFileSize"
                                    :column="column"
                                    v-bind="$attrs">
                </DataGridFileUpload>
                <div v-if="column.inputTip"
                     class="input-tip">{{column.inputTip}}</div>
              </el-form-item>
            </template>
            <el-form-item :label="column.name"
                          :prop="column._prop"
                          :rules="getFormItemUpdateRule(column)"
                          v-else>
              <template v-if="column.inputConfig.elementType === 'DATE_FIELD'">
                <el-date-picker v-model="updateDataDialog.form[column._prop]"
                                type="date"
                                prefix-icon="el-icon-date"
                                value-format="yyyy-MM-dd"
                                :placeholder="column.name"
                                style="width: 100%">
                </el-date-picker>
              </template>
              <template v-else-if="column.inputConfig.elementType === 'TIME_FIELD'">
                <el-time-picker v-model="updateDataDialog.form[column._prop]"
                                :placeholder="column.name"
                                prefix-icon="el-icon-time"
                                format="HH:mm"
                                value-format="HH:mm"
                                style="width: 100%">
                </el-time-picker>
              </template>
              <template v-else-if="column.inputConfig.elementType === 'DATETIME_FIELD'">
                <el-date-picker v-model="updateDataDialog.form[column._prop]"
                                type="datetime"
                                prefix-icon="el-icon-date"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :placeholder="column.name"
                                style="width: 100%">
                </el-date-picker>
              </template>
              <template v-else-if="column.inputConfig.elementType === 'TIME_DETAIL_FIELD'">
                <el-time-picker v-model="updateDataDialog.form[column._prop]"
                                :placeholder="column.name"
                                prefix-icon="el-icon-time"
                                value-format="HH:mm:ss"
                                style="width: 100%">
                </el-time-picker>
              </template>
              <template v-else-if="column.inputConfig.elementType === 'CUSTOM_DATE_FIELD'">
                <el-date-picker v-if="column.inputConfig.inputType"
                                v-model="updateDataDialog.form[column._prop]"
                                :type="column.inputConfig.inputType.type"
                                prefix-icon="el-icon-date"
                                :format="column.inputConfig.inputType.format"
                                :value-format="column.inputConfig.inputType.valueFormat"
                                :placeholder="column.name"
                                style="width: 100%">
                </el-date-picker>
              </template>
              <template v-else-if="column.inputConfig.elementType === 'DROP_DOWN_SELECT_LIST'">
                <DataGridDataSelect v-model="updateDataDialog.form[column._prop]"
                                    :column="column"
                                    :label-prop="column.inputConfig.apiData.valueProp"
                                    :value-prop="column.inputConfig.apiData.keyProp"
                                    :multi-prop="column.inputConfig.apiData.multiProp"
                                    :ref-options="updateDataDialog.form[`${column._prop}_$ref`]"
                                    v-bind="$attrs">
                </DataGridDataSelect>
              </template>
              <template v-else-if="column.inputConfig.elementType === 'DROP_DOWN_SELECT_PAGE'">
                <DataGridDataSelect v-model="updateDataDialog.form[column._prop]"
                                    :column="column"
                                    :label-prop="column.inputConfig.apiData.valueProp"
                                    :value-prop="column.inputConfig.apiData.keyProp"
                                    :multi-prop="column.inputConfig.apiData.multiProp"
                                    :ref-options="updateDataDialog.form[`${column._prop}_$ref`]"
                                    :pageable="true"
                                    v-bind="$attrs">
                </DataGridDataSelect>
              </template>
              <template v-else-if="column.inputConfig.elementType === 'CASCADER_SELECT'">
                <DataGridDataCascader v-model="addDataDialog.form[column._prop]"
                                      :column="column"
                                      :label-prop="column.inputConfig.apiData.labelProp"
                                      :value-prop="column.inputConfig.apiData.valueProp"
                                      :children-prop="column.inputConfig.apiData.childrenProp"
                                      :ref-options="updateDataDialog.form[`${column._prop}_$ref`]"
                                      v-bind="$attrs">
                </DataGridDataCascader>
              </template>
              <template v-else-if="column.inputConfig.elementType === 'PASSWORD_FIELD'">
                <PasswordField v-model="updateDataDialog.form[column._prop]"
                               :maxlength="column.maxLength > 0 ? column.maxLength : null"
                               :placeholder="column.name"
                               style="width: 100%"></PasswordField>
              </template>
              <template v-else-if="column.inputConfig.elementType === 'TEXTAREA'">
                <el-input v-model="updateDataDialog.form[column._prop]"
                          type="textarea"
                          :maxlength="column.maxLength > 0 ? column.maxLength : null"
                          :placeholder="column.name"
                          style="width: 100%"></el-input>
              </template>
              <template v-else-if="column.inputConfig.elementType === 'RICH_EDITOR'">
                <AmEditor v-model="updateDataDialog.form[column._prop]"
                          :placeholder="column.name"></AmEditor>
              </template>
              <template v-else-if="column.inputConfig.acceptType">
                <template v-if="column.inputConfig.acceptType.type === 'NUMBER'">
                  <template v-if="column.renderCell && column.renderCell.cellType && column.renderCell.cellType.type === 'rate' && column.renderCell.cellType.cell">
                    <el-rate v-model="updateDataDialog.form[column._prop]"
                             :max="column.renderCell.cellType.cell.maxValue"
                             show-score
                             allow-half></el-rate>
                  </template>
                  <el-input v-model="updateDataDialog.form[column._prop]"
                            type="number"
                            :maxlength="column.maxLength > 0 ? column.maxLength : null"
                            :placeholder="column.name"
                            v-else
                            style="width: 100%"></el-input>
                </template>
                <el-input v-model="updateDataDialog.form[column._prop]"
                          :maxlength="column.maxLength > 0 ? column.maxLength : null"
                          :placeholder="column.name"
                          v-else
                          style="width: 100%"></el-input>
              </template>
              <template v-else>
                <el-input v-model="updateDataDialog.form[column._prop]"
                          :maxlength="column.maxLength > 0 ? column.maxLength : null"
                          :placeholder="column.name"
                          style="width: 100%"></el-input>
              </template>
              <div v-if="column.inputTip"
                   class="input-tip">{{column.inputTip}}</div>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item :label="column.name"
                          :prop="column._prop"
                          :rules="getFormItemUpdateRule(column)">
              <template v-if="column.renderCell && column.renderCell.cellType && column.renderCell.cellType.type === 'switch' && column.renderCell.cellType.cell">
                <el-switch v-model="updateDataDialog.form[column._prop]"
                           :active-value="column.renderCell.cellType.cell.activeValue"
                           :inactive-value="column.renderCell.cellType.cell.inactiveValue || false"></el-switch>
              </template>
              <el-input v-model="updateDataDialog.form[column._prop]"
                        :maxlength="column.maxLength > 0 ? column.maxLength : null"
                        :placeholder="column.name"
                        v-else
                        style="width: 100%"></el-input>
              <div v-if="column.inputTip"
                   class="input-tip">{{column.inputTip}}</div>
            </el-form-item>
          </template>
        </div>
      </el-form>
      <span slot="footer">
        <el-button type="primary" size="mini" :disabled="isLoadingUpdate || updateDataDialog.isCommitting" @click="submitUpdateData">提交更新</el-button>
        <el-button size="mini" @click="updateDataDialog.isShow = false">关闭窗口</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-if="gridData.config.exportConfig && gridData.config.exportConfig.length > 0 && dataExportDialog.isRender"
      v-el-drag-dialog
      :title="gridData.config.title + ' - 数据导出'"
      width="600px"
      custom-class="grid-data-export-dialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      :center="true"
      :visible.sync="dataExportDialog.isShow">
      <el-form label-width="100px"
               label-suffix="："
               size="mini"
               v-loading="dataExportDialog.isExporting"
               element-loading-text="数据导出中，请稍等...">
        <el-form-item label="导出标题">
          <el-input v-model="dataExportDialog.exportTitle"
                    maxlength="50"
                    :placeholder="gridData.config.title"/>
        </el-form-item>
        <el-form-item label="导出格式">
          <el-radio v-for="(config, index) in gridData.config.exportConfig"
                    v-model="dataExportDialog.exportType"
                    :key="'grid-data-export-type' + index"
                    :label="config.type">{{config.description}}</el-radio>
        </el-form-item>
        <el-form-item label="选择范围">
          <el-radio v-for="(scope, index) in dataExportDialog.scopes"
                    v-model="dataExportDialog.exportScope"
                    :key="'grid-data-export-scope' + index"
                    :label="scope.type">{{scope.label}}
            <span v-if="scope.type === 'selection'">
              ( {{selection.length}} )
            </span>
            <span v-if="scope.type === 'current'">
              ( {{gridData.rowList ? gridData.rowList.length : 0}} )
            </span>
            <span v-if="scope.type === 'all'">
              <template v-if="!gridData.raw || !gridData.raw.optimizePage">( {{gridData.totalCount}} )</template>
            </span>
          </el-radio>
        </el-form-item>
        <el-form-item label="选择字段">
          <div class="export-prop-list">
            <AppScrollbar style="height: 160px">
              <div class="export-prop-item theme-light-bg">
                <el-checkbox v-model="dataExportDialog.exportLine">行号（#）</el-checkbox>
              </div>
              <el-checkbox-group v-model="dataExportDialog.exportProps">
                <div class="export-prop-item"
                     v-for="(column, index) in gridExportableColumns"
                     :key="'grid-data-export-item' + index">
                  <el-checkbox :label="column.prop">{{column.name}}</el-checkbox>
                </div>
              </el-checkbox-group>
            </AppScrollbar>
          </div>
          <div class="export-prop-foot">
            <el-button size="mini" type="text" @click="handleExportSelectAll">全选</el-button>
            <span class="divider">/</span>
            <el-button size="mini" type="text" @click="handleExportSelectReverse">反选</el-button>
          </div>
        </el-form-item>
      </el-form>
      <transition name="el-zoom-in-bottom">
        <div class="export-result"
             v-if="dataExportDialog.isShowResult">
          <DataExportResult v-bind="$extend(dataExportDialog.exportResult, $attrs)"></DataExportResult>
        </div>
      </transition>
      <span slot="footer">
        <el-button type="primary" size="mini" :disabled="dataExportDialog.isExporting" v-if="!dataExportDialog.isShowResult" @click="startExportData">开始导出</el-button>
        <el-button type="primary" size="mini" plain v-if="dataExportDialog.isShowResult" @click="dataExportDialog.isShowResult = false">重新设置</el-button>
        <el-button size="mini" @click="dataExportDialog.isShow = false">关闭窗口</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-if="dataPrintDialog.isRender"
      v-el-drag-dialog
      :title="gridData.config.title + ' - 数据打印'"
      width="600px"
      custom-class="grid-data-print-dialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      :center="true"
      :visible.sync="dataPrintDialog.isShow">
      <el-form label-width="100px"
               label-suffix="："
               size="mini">
        <el-form-item label="基础配置">
          <el-checkbox v-model="dataPrintDialog.printHeader">打印表头</el-checkbox>
        </el-form-item>
        <el-form-item label="打印范围">
          <el-radio v-for="(scope, index) in dataPrintDialog.scopes"
                    v-model="dataPrintDialog.printScope"
                    :key="'grid-data-print-scope' + index"
                    :label="scope.type">{{scope.label}}
            <span v-if="scope.type === 'selection'">
              ( {{selection.length}} )
            </span>
            <span v-if="scope.type === 'all'">
              ( {{gridData.rowList ? gridData.rowList.length : 0}} )
            </span>
          </el-radio>
        </el-form-item>
        <el-form-item label="打印字段">
          <el-radio v-for="(field, index) in dataPrintDialog.fields"
                    v-model="dataPrintDialog.printField"
                    :key="'grid-data-print-field' + index"
                    :label="field.type">
            {{field.label}}
          </el-radio>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" size="mini" @click="startPrintData">开始打印</el-button>
        <el-button size="mini" @click="dataPrintDialog.isShow = false">关闭窗口</el-button>
      </span>
    </el-dialog>
    <el-dialog v-for="(importMenuAction, index) in gridImportMenuActions"
               :key="'grid-import-menu-action' + index"
               v-if="importMenuAction.isRenderImport"
               v-el-drag-dialog
               :append-to-body="true"
               :close-on-click-modal="false"
               :visible.sync="importMenuAction.isShowImport"
               v-bind="$extend({
                 title: importMenuAction.name,
                 width: computeDialogWidth(importMenuAction.dimension),
                 center: true
               }, importMenuAction.extraAttrs)">
      <DataImportModule :import-url="importMenuAction.actionPath"
                        :extra-params="importMenuAction.extraParams"
                        :pre-handle-params="() => getPreHandleParams(importMenuAction)"
                        v-bind="$attrs"
                        @dataImportSuccess="dataImportSuccess">
        <span slot="external">
          <el-button size="mini" @click="importMenuAction.isShowImport = false">关闭窗口</el-button>
        </span>
      </DataImportModule>
    </el-dialog>
    <el-dialog v-for="(unpackMenuAction, index) in gridUnpackMenuActions"
               :key="'grid-unpack-menu-action' + index"
               v-if="unpackMenuAction.isRenderUnpack"
               v-el-drag-dialog
               :append-to-body="true"
               :close-on-click-modal="false"
               :visible.sync="unpackMenuAction.isShowUnpack"
               v-bind="$extend({
                 title: unpackMenuAction.name,
                 width: computeDialogWidth(unpackMenuAction.dimension),
                 center: true
               }, unpackMenuAction.extraAttrs)">
      <DataUnpackModule :unpack-url="unpackMenuAction.actionPath"
                        :extra-params="unpackMenuAction.extraParams"
                        :pre-handle-params="() => getPreHandleParams(unpackMenuAction)"
                        v-bind="$attrs"
                        @dataUnpackSuccess="dataUnpackSuccess">
        <span slot="external">
          <el-button size="mini" @click="unpackMenuAction.isShowUnpack = false">关闭窗口</el-button>
        </span>
      </DataUnpackModule>
    </el-dialog>
    <el-dialog v-for="(asyncMenuAction, index) in gridAsyncMenuActions"
               :key="'grid-async-menu-action' + index"
               v-if="asyncMenuAction.isRenderAsync"
               v-el-drag-dialog
               :append-to-body="true"
               :close-on-click-modal="false"
               :visible.sync="asyncMenuAction.isShowAsync"
               v-bind="$extend({
                 title: asyncMenuAction.name,
                 width: computeDialogWidth(asyncMenuAction.dimension),
                 center: true
               }, asyncMenuAction.extraAttrs)">
      <AsyncTaskModule :action-url="asyncMenuAction.actionPath"
                       :confirm-msg="asyncMenuAction.confirmMsg"
                       :extra-params="asyncMenuAction.extraParams"
                       :pre-handle-params="() => getPreHandleParams(asyncMenuAction)"
                       v-bind="$attrs"
                       @onComplete="asyncTaskSuccess">
      </AsyncTaskModule>
    </el-dialog>
    <DataGridDialog v-for="(popupMenuAction, index) in gridPopupMenuActions"
                    :key="'grid-popup-menu-action' + index"
                    v-if="popupMenuAction.isRenderPopup"
                    :visible.sync="popupMenuAction.isShowPopup"
                    :decorator="popupMenuAction.decorator"
                    v-bind="$extend({
                      title: popupMenuAction.name,
                      width: computeDialogWidth(popupMenuAction.dimension),
                      center: true
                    }, popupMenuAction.extraAttrs)">
      <template slot-scope="scope">
        <div :style="computeDialogWrapStyle(popupMenuAction.dimension)">
          <DataGridPopover :component-path="popupMenuAction.actionPath"
                           :visible="popupMenuAction.isShowPopup"
                           :grid-data="gridData"
                           :extra-key="popupMenuAction.extraKey"
                           :extra-id="selection"
                           :extra-value="selection"
                           :extra-params="popupMenuAction.extraParams"
                           :pre-handle-params="() => getPreHandleParams(popupMenuAction)"
                           :popover-extra="scope"
                           v-bind="$attrs"
                           @reloadGridData="reloadGridData"
                           @hidePopover="hidePopup(popupMenuAction)"
                           @hidePopoverAndRefresh="hidePopupAndRefresh(popupMenuAction)"
                           @hidePopup="hidePopup(popupMenuAction)"
                           @hidePopupAndRefresh="hidePopupAndRefresh(popupMenuAction)"></DataGridPopover>
        </div>
      </template>
    </DataGridDialog>
    <DataGridDrawer v-for="(drawerMenuAction, index) in gridDrawerMenuActions"
                    :key="'grid-drawer-menu-action' + index"
                    v-if="drawerMenuAction.isRenderDrawer"
                    :class="drawerMenuAction.dimension ? 'dimension--' + drawerMenuAction.dimension.type : ''"
                    :visible.sync="drawerMenuAction.isShowDrawer"
                    :decorator="drawerMenuAction.decorator"
                    v-bind="drawerMenuAction.extraAttrs">
      <template slot-scope="scope">
        <DataGridPopover :component-path="drawerMenuAction.actionPath"
                         :visible="drawerMenuAction.isShowDrawer"
                         :grid-data="gridData"
                         :extra-key="drawerMenuAction.extraKey"
                         :extra-id="selection"
                         :extra-value="selection"
                         :extra-params="drawerMenuAction.extraParams"
                         :pre-handle-params="() => getPreHandleParams(drawerMenuAction)"
                         :popover-extra="scope"
                         v-bind="$attrs"
                         @reloadGridData="reloadGridData"
                         @hidePopover="hideDrawer(drawerMenuAction)"
                         @hidePopoverAndRefresh="hideDrawerAndRefresh(drawerMenuAction)"
                         @hideDrawer="hideDrawer(drawerMenuAction)"
                         @hideDrawerAndRefresh="hideDrawerAndRefresh(drawerMenuAction)"></DataGridPopover>
      </template>
    </DataGridDrawer>
    <DataGridCascade v-for="(cascadeMenuAction, index) in gridCascadeMenuActions"
                     :key="'grid-cascade-menu-action' + index"
                     v-if="cascadeMenuAction.isRenderCascade"
                     :visible.sync="cascadeMenuAction.isShowCascade"
                     :decorator="cascadeMenuAction.decorator"
                     v-bind="$extend({
                       content: cascadeMenuAction.name
                     }, cascadeMenuAction.extraAttrs)">
      <template slot-scope="scope">
        <DataGridPopover :component-path="cascadeMenuAction.actionPath"
                         :visible="cascadeMenuAction.isShowCascade"
                         :grid-data="gridData"
                         :extra-key="cascadeMenuAction.extraKey"
                         :extra-id="selection"
                         :extra-value="selection"
                         :extra-params="cascadeMenuAction.extraParams"
                         :pre-handle-params="() => getPreHandleParams(cascadeMenuAction)"
                         :popover-extra="scope"
                         v-bind="$attrs"
                         @reloadGridData="reloadGridData"
                         @hidePopover="hideCascade(cascadeMenuAction)"
                         @hidePopoverAndRefresh="hideCascadeAndRefresh(cascadeMenuAction)"
                         @hideCascade="hideCascade(cascadeMenuAction)"
                         @hideCascadeAndRefresh="hideCascadeAndRefresh(cascadeMenuAction)"></DataGridPopover>
      </template>
    </DataGridCascade>
  </div>
</template>

<script>
import elDragDialog from '../../../directive/elDialogDrag'
import { getValueByPath } from 'element-ui/lib/utils/util'
import baseApiUrl from '../../../constants/baseApiUrl'
import routeConfig from '../../../constants/routeConfig'
import globalEvent from '../../../constants/globalEvent'
import DataGridDataSelect from './DataGridDataSelect'
import DataGridDataCascader from './DataGridDataCascader'
import DataGridImageUpload from './DataGridImageUpload'
import DataGridFileUpload from './DataGridFileUpload'
import AmEditor from '../editor/AmEditor'
import DataImportModule from '../DataImportModule'
import DataUnpackModule from '../DataUnpackModule'
import AsyncTaskModule from '../AsyncTaskModule'
import DataGridPopover from '../grid/DataGridPopover'
import DataGridDialog from './DataGridDialog'
import DataGridDrawer from './DataGridDrawer'
import DataGridBubble from './DataGridBubble'
import DataGridCascade from './DataGridCascade'
import Tile from '../Tile'
import AppScrollbar from '../AppScrollbar'
import PasswordField from '../PasswordField'
import DataGridColumnEditor from './DataGridColumnEditor'
import DataExportResult from './wrapper/DataExportResult'
import { Loading } from 'element-ui'
import deviceUtils from '../../../util/deviceUtils'
export default {
  name: 'DataGridFunctionMenu',
  inject: ['$grid'],
  directives: {elDragDialog},
  components: {
    DataGridDataSelect,
    DataGridDataCascader,
    DataGridFileUpload,
    DataGridImageUpload,
    AmEditor,
    DataImportModule,
    DataUnpackModule,
    AsyncTaskModule,
    DataGridPopover,
    DataGridDialog,
    DataGridDrawer,
    DataGridBubble,
    DataGridCascade,
    Tile,
    AppScrollbar,
    PasswordField,
    DataGridColumnEditor,
    DataExportResult
  },
  props: {
    gridData: {
      required: true,
      type: Object
    },
    gridSearch: {
      required: true,
      type: Object
    },
    singleMode: {
      type: Boolean
    }
  },
  provide () {
    return {
      $menu: this
    }
  },
  data () {
    return {
      selectAll: false,
      submitFormOption: {
        action: '',
        method: '',
        target: '',
        postParams: null
      },
      addDataDialog: {
        isRender: false,
        isShow: false,
        isLoading: false,
        isCommitting: false,
        form: {}
      },
      updateDataDialog: {
        isRender: false,
        isShow: false,
        isLoading: false,
        isCommitting: false,
        form: {
          id: null
        }
      },
      dataExportDialog: {
        isRender: false,
        isShow: false,
        isExporting: false,
        scopes: [{
          type: 'selection',
          label: '当前勾选'
        }, {
          type: 'current',
          label: '当前页'
        }, {
          type: 'all',
          label: '全部'
        }],
        exportTitle: '',
        exportType: '',
        exportScope: 'current',
        exportLine: true,
        exportProps: [],
        isShowResult: false,
        exportResult: {
          optimizeTask: undefined,
          fileName: null,
          downloadLink: null
        }
      },
      dataPrintDialog: {
        isRender: false,
        isShow: false,
        printHeader: true,
        printScope: 'all',
        printField: 'default',
        scopes: [{
          type: 'selection',
          label: '当前勾选数据'
        }, {
          type: 'all',
          label: '表格显示数据'
        }],
        fields: [{
          type: 'default',
          label: '默认'
        }, {
          type: 'all',
          label: '全部'
        }]
      }
    }
  },
  computed: {
    selection: function () {
      let ids = []
      if (this.gridData.rowSelection) {
        this.gridData.rowSelection.forEach((column) => {
          ids.push(column.id)
        })
      }
      return ids
    },
    isPreciseMode: function () {
      return !this.singleMode && this.selection.length > 0
    },
    allowSelectAll: function () {
      if (this.gridData.config && this.gridData.config.isAllowSelectAll) {
        if (this.gridData.rowList && this.gridData.rowList.length > 0) {
          if (this.gridData.totalCount > this.gridData.rowList.length && this.gridData.rowSelection) {
            return this.gridData.rowList.length === this.gridData.rowSelection.length
          }
        }
      }
      return false
    },
    isSelectAll: function () {
      return this.allowSelectAll && this.selectAll
    },
    gridAddableColumns: function () {
      let columns = this.gridData.config ? this.gridData.config.columns : null
      if (columns) {
        let addableColumns = []
        columns.forEach((column, index) => {
          this.computeAddableColumn(column, addableColumns)
        })
        return addableColumns
      } else {
        return null
      }
    },
    gridUpdatableColumns: function () {
      let columns = this.gridData.config ? this.gridData.config.columns : null
      if (columns) {
        let updatableColumns = []
        columns.forEach((column, index) => {
          this.computeUpdatableColumn(column, updatableColumns)
        })
        return updatableColumns
      } else {
        return null
      }
    },
    gridExportableColumns: function () {
      let columns = this.gridData.config ? this.gridData.config.columns : null
      if (columns) {
        let exportableColumns = []
        columns.forEach((column, index) => {
          this.computeExportableColumn(column, exportableColumns)
        })
        return exportableColumns
      } else {
        return null
      }
    },
    gridImportMenuActions: function () {
      let menus = this.gridData.config.menus
      if (menus) {
        let importMenuActions = []
        menus.forEach((menu, index) => {
          let menuAction = menu.menuAction
          if (menuAction) {
            this.computeImportMenuAction(menuAction, importMenuActions)
          }
        })
        return importMenuActions
      } else {
        return null
      }
    },
    gridUnpackMenuActions: function () {
      let menus = this.gridData.config.menus
      if (menus) {
        let unpackMenuActions = []
        menus.forEach((menu, index) => {
          let menuAction = menu.menuAction
          if (menuAction) {
            this.computeUnpackMenuAction(menuAction, unpackMenuActions)
          }
        })
        return unpackMenuActions
      } else {
        return null
      }
    },
    gridAsyncMenuActions: function () {
      let menus = this.gridData.config.menus
      if (menus) {
        let asyncMenuActions = []
        menus.forEach((menu, index) => {
          let menuAction = menu.menuAction
          if (menuAction) {
            this.computeAsyncMenuAction(menuAction, asyncMenuActions)
          }
        })
        return asyncMenuActions
      } else {
        return null
      }
    },
    gridPopupMenuActions: function () {
      let menus = this.gridData.config.menus
      if (menus) {
        let popupMenuActions = []
        menus.forEach((menu, index) => {
          let menuAction = menu.menuAction
          if (menuAction) {
            this.computePopupMenuAction(menuAction, popupMenuActions)
          }
        })
        return popupMenuActions
      } else {
        return null
      }
    },
    gridDrawerMenuActions: function () {
      let menus = this.gridData.config.menus
      if (menus) {
        let drawerMenuActions = []
        menus.forEach((menu, index) => {
          let menuAction = menu.menuAction
          if (menuAction) {
            this.computeDrawerMenuAction(menuAction, drawerMenuActions)
          }
        })
        return drawerMenuActions
      } else {
        return null
      }
    },
    gridBubbleMenuActions: function () {
      let menus = this.gridData.config.menus
      if (menus) {
        let bubbleMenuActions = []
        menus.forEach((menu, index) => {
          let menuAction = menu.menuAction
          if (menuAction) {
            this.computeBubbleMenuAction(menuAction, bubbleMenuActions)
          }
        })
        return bubbleMenuActions
      } else {
        return null
      }
    },
    gridCascadeMenuActions: function () {
      let menus = this.gridData.config.menus
      if (menus) {
        let cascadeMenuActions = []
        menus.forEach((menu, index) => {
          let menuAction = menu.menuAction
          if (menuAction) {
            this.computeCascadeMenuAction(menuAction, cascadeMenuActions)
          }
        })
        return cascadeMenuActions
      } else {
        return null
      }
    },
    isLoadingAdd: function () {
      let columns = this.gridAddableColumns
      if (columns) {
        let prepared = columns.every(c => !c.isLoadingAdd)
        if (!prepared) {
          return true
        }
      }
      return this.addDataDialog.isLoading
    },
    isLoadingUpdate: function () {
      let columns = this.gridUpdatableColumns
      if (columns) {
        let prepared = columns.every(c => !c.isLoadingUpdate)
        if (!prepared) {
          return true
        }
      }
      return this.updateDataDialog.isLoading
    }
  },
  methods: {
    // 是否选择全部
    toggleSelectAll () {
      this.selectAll = !this.selectAll
    },
    // 获取可添加列
    computeAddableColumn (column, addableColumns) {
      let childColumns = column['childColumns']
      if (childColumns && childColumns.length > 0) {
        childColumns.forEach((c, i) => {
          this.computeAddableColumn(c, addableColumns)
        })
      } else {
        if (column['isAddable']) {
          addableColumns.push(column)
        }
      }
    },
    // 获取可更新列
    computeUpdatableColumn (column, updatableColumns) {
      let childColumns = column['childColumns']
      if (childColumns && childColumns.length > 0) {
        childColumns.forEach((c, i) => {
          this.computeUpdatableColumn(c, updatableColumns)
        })
      } else {
        if (column['isUpdatable']) {
          updatableColumns.push(column)
        }
      }
    },
    // 获取可导出列
    computeExportableColumn (column, exportableColumns) {
      let childColumns = column['childColumns']
      if (childColumns && childColumns.length > 0) {
        childColumns.forEach((c, i) => {
          this.computeExportableColumn(c, exportableColumns)
        })
      } else {
        if (column['isExportable']) {
          exportableColumns.push(column)
        }
      }
    },
    // 获取可导入菜单
    computeImportMenuAction (menuAction, importMenuActions) {
      if (menuAction.handlerType === 'IMPORT') {
        importMenuActions.push(menuAction)
      }
      let menuActionList = menuAction.menuActionList
      if (menuActionList && menuActionList.length > 0) {
        menuActionList.forEach((m, i) => {
          this.computeImportMenuAction(m, importMenuActions)
        })
      }
    },
    // 获取可拆包菜单
    computeUnpackMenuAction (menuAction, unpackMenuActions) {
      if (menuAction.handlerType === 'UNPACK') {
        unpackMenuActions.push(menuAction)
      }
      let menuActionList = menuAction.menuActionList
      if (menuActionList && menuActionList.length > 0) {
        menuActionList.forEach((m, i) => {
          this.computeUnpackMenuAction(m, unpackMenuActions)
        })
      }
    },
    // 获取异步任务菜单
    computeAsyncMenuAction (menuAction, asyncMenuActions) {
      if (menuAction.handlerType === 'ASYNC') {
        asyncMenuActions.push(menuAction)
      }
      let menuActionList = menuAction.menuActionList
      if (menuActionList && menuActionList.length > 0) {
        menuActionList.forEach((m, i) => {
          this.computeAsyncMenuAction(m, asyncMenuActions)
        })
      }
    },
    // 获取可弹出菜单
    computePopupMenuAction (menuAction, popupMenuActions) {
      if (menuAction.handlerType === 'POPUP') {
        popupMenuActions.push(menuAction)
      }
      let menuActionList = menuAction.menuActionList
      if (menuActionList && menuActionList.length > 0) {
        menuActionList.forEach((m, i) => {
          this.computePopupMenuAction(m, popupMenuActions)
        })
      }
    },
    // 获取抽屉菜单
    computeDrawerMenuAction (menuAction, drawerMenuActions) {
      if (menuAction.handlerType === 'DRAWER') {
        drawerMenuActions.push(menuAction)
      }
      let menuActionList = menuAction.menuActionList
      if (menuActionList && menuActionList.length > 0) {
        menuActionList.forEach((m, i) => {
          this.computeDrawerMenuAction(m, drawerMenuActions)
        })
      }
    },
    // 获取气泡菜单
    computeBubbleMenuAction (menuAction, drawerMenuActions) {
      if (menuAction.handlerType === 'BUBBLE') {
        drawerMenuActions.push(menuAction)
      }
      let menuActionList = menuAction.menuActionList
      if (menuActionList && menuActionList.length > 0) {
        menuActionList.forEach((m, i) => {
          this.computeBubbleMenuAction(m, drawerMenuActions)
        })
      }
    },
    // 获取层叠菜单
    computeCascadeMenuAction (menuAction, cascadeMenuActions) {
      if (menuAction.handlerType === 'CASCADE') {
        cascadeMenuActions.push(menuAction)
      }
      let menuActionList = menuAction.menuActionList
      if (menuActionList && menuActionList.length > 0) {
        menuActionList.forEach((m, i) => {
          this.computeCascadeMenuAction(m, cascadeMenuActions)
        })
      }
    },
    // 获取弹窗宽度
    computeDialogWidth (dimension) {
      if (dimension && dimension.width) {
        return dimension.width + 'px'
      } else {
        return null
      }
    },
    // 获取弹窗内部样式
    computeDialogWrapStyle (dimension) {
      let style = {}
      if (dimension) {
        if (dimension.height) {
          style.height = dimension.height + 'px'
        }
      }
      return style
    },
    // 获取表单添加规则
    getFormItemAddRule (column, isLink) {
      let rules = []
      let trigger = ['blur', 'change']
      // 不允许为空
      if (!column.isAllowBlank) {
        rules.push({
          required: true,
          message: '请设置' + column.name,
          trigger: trigger
        })
      }
      if (typeof column.maxLength === 'number' && column.maxLength > 0) {
        rules.push({
          validator: (rule, value, callback) => { this.validateInputLength(rule, value, callback, column) },
          trigger: trigger
        })
      }
      if (column.inputConfig) {
        let acceptType = column.inputConfig.acceptType
        if (acceptType) {
          rules.push({
            validator: (rule, value, callback) => { this.validateFormItem(rule, value, callback, column, acceptType, isLink) },
            trigger: trigger
          })
        }
      }
      return rules
    },
    // 获取表单更新规则
    getFormItemUpdateRule (column, isLink) {
      let rules = []
      let trigger = ['blur', 'change']
      // 不允许为空并且不支持空值不更新
      if (!column.isAllowBlank && !column.isIgnoreEmptyWhenUpdate) {
        rules.push({
          required: true,
          message: '请设置' + column.name,
          trigger: trigger
        })
      }
      if (typeof column.maxLength === 'number' && column.maxLength > 0) {
        rules.push({
          validator: (rule, value, callback) => { this.validateInputLength(rule, value, callback, column) },
          trigger: trigger
        })
      }
      if (column.inputConfig) {
        let acceptType = column.inputConfig.acceptType
        if (acceptType) {
          rules.push({
            validator: (rule, value, callback) => { this.validateFormItem(rule, value, callback, column, acceptType, isLink) },
            trigger: trigger
          })
        }
      }
      return rules
    },
    // 验证字段长度
    validateInputLength (rule, value, callback, column) {
      if (value && value.length > column.maxLength) {
        callback(new Error(column.name + '长度不能超过' + column.maxLength))
        return
      }
      callback()
    },
    // 表单的验证信息
    validateFormItem (rule, value, callback, column, acceptType, isLink) {
      if (value && acceptType && !isLink) {
        if (acceptType.type === 'NUMBER') {
          if (isNaN(value)) {
            callback(new Error(column.name + '只接受数值类型'))
            return
          }
        }
        let validators = acceptType.validators
        if (validators) {
          for (let index = 0; index < validators.length; index++) {
            let validator = validators[index]
            if (validator && validator.type) {
              let validate = validator.validate
              if (validate) {
                switch (validator.type) {
                  case 'regex': {
                    let regexText = validate.regex
                    if (regexText) {
                      let regex = new RegExp('^' + regexText + '$')
                      if (!regex.test(`${value}`)) {
                        callback(new Error(validate.hint || column.name + '填写不合法'))
                        return
                      }
                    }
                    break
                  }
                  case 'scopedNumber': {
                    let getNumber = Number(value)
                    if (typeof validate.minValue !== 'undefined' && validate.minValue != null) {
                      if (getNumber < validate.minValue) {
                        callback(new Error(validate.hint || column.name + '填写不合法'))
                        return
                      }
                    }
                    if (typeof validate.maxValue !== 'undefined' && validate.maxValue != null) {
                      if (getNumber > validate.maxValue) {
                        callback(new Error(validate.hint || column.name + '填写不合法'))
                        return
                      }
                    }
                    break
                  }
                  case 'suffix': {
                    let suffix = validate.suffix
                    if (suffix) {
                      let input = value.toLowerCase()
                      if (!suffix.some(val => input.endsWith(val))) {
                        callback(new Error(validate.hint || column.name + '类型不合法'))
                      }
                    }
                    break
                  }
                }
              }
            }
          }
        }
      }
      callback()
    },
    // 点击后退按钮
    handleBack () {
      this.$router.back()
    },
    // 触发更新事件（向上层传递事件）
    triggerDataChange (changeType) {
      this.$grid.triggerDataChange(changeType)
    },
    // 点击添加按钮
    handleAddData () {
      let gridAddableColumns = this.gridAddableColumns
      if (gridAddableColumns) {
        gridAddableColumns.forEach((column) => {
          if (column.inputConfig) {
            if ((column.inputConfig.elementType === 'DROP_DOWN_SELECT_LIST' || column.inputConfig.elementType === 'DROP_DOWN_SELECT_PAGE') && column.inputConfig.apiData.multiProp) {
              this.addDataDialog.form[column._prop] = []
            }
          }
        })
      }
      this.addDataDialog.isRender = true
      this.$nextTick(() => {
        this.addDataDialog.isShow = true
      })
    },
    // 提交添加数据
    submitAddData () {
      this.$refs['gridAddDataForm'].validate((valid) => {
        if (valid) {
          let postParams = this.$extend(this.$attrs)
          if (!postParams[routeConfig.DataGrid.param]) {
            return
          }
          let gridAddableColumns = this.gridAddableColumns
          if (gridAddableColumns) {
            let addParams = {}
            gridAddableColumns.forEach((column) => {
              addParams['bean.' + column.prop] = this.addDataDialog.form[column._prop]
              if (column.inputConfig) {
                if (column.inputConfig.elementType === 'IMAGE_UPLOAD' || column.inputConfig.elementType === 'FILE_UPLOAD') {
                  addParams['bean.' + column.prop + '_filename'] = this.addDataDialog.form[column._prop + '_filename']
                }
              }
            })
            let params = this.$extend({
              requestType: 'add'
            }, addParams, postParams)
            // 发送添加请求
            this.addDataDialog.isCommitting = true
            this.$ajax({
              url: baseApiUrl.DataGridUrl,
              method: 'post',
              data: this.$qs.stringify(params, {
                arrayFormat: 'repeat'
              })
            }).then((response) => {
              if (response.data) {
                switch (response.data['responseCode']) {
                  case 'SUCCESS': {
                    this.$message({
                      message: response.data['message'],
                      type: 'success',
                      center: true
                    })
                    // 结果处理
                    this.addDataDialog.isShow = false
                    this.$nextTick(() => {
                      this.triggerDataChange('add')
                      this.reloadGridData()
                    })
                    break
                  }
                  default: {
                    this.$message({
                      message: response.data['message'],
                      type: 'warning',
                      center: true
                    })
                    break
                  }
                }
              }
            }, () => {
              this.$message.error({
                message: '请求发送失败，请稍候重试',
                center: true
              })
            }).finally(() => {
              this.addDataDialog.isCommitting = false
            })
          } else {
            this.$message.error({
              message: '表格添加信息缺失',
              center: true
            })
          }
        }
      })
    },
    // 更新数据
    handleUpdateData (row) {
      if (this.gridData.config && this.gridData.config.isCanUpdate) {
        let postParams = this.$extend(this.$attrs)
        if (!postParams[routeConfig.DataGrid.param]) {
          return
        }
        let gridUpdatableColumns = this.gridUpdatableColumns
        if (gridUpdatableColumns) {
          gridUpdatableColumns.forEach((column) => {
            if (column.inputConfig) {
              if ((column.inputConfig.elementType === 'DROP_DOWN_SELECT_LIST' || column.inputConfig.elementType === 'DROP_DOWN_SELECT_PAGE') && column.inputConfig.apiData.multiProp) {
                this.updateDataDialog.form[column._prop] = []
              }
            }
          })
        }
        // 清除旧数据
        Object.keys(this.updateDataDialog.form).forEach(key => {
          if (Array.isArray(this.updateDataDialog.form[key])) {
            this.updateDataDialog.form[key] = []
          } else if (typeof this.updateDataDialog.form[key] === 'number') {
            this.updateDataDialog.form[key] = undefined
          } else {
            this.updateDataDialog.form[key] = ''
          }
        })
        this.updateDataDialog.isRender = true
        this.$nextTick(() => {
          this.clearValidate('gridUpdateDataForm')
          this.updateDataDialog.isShow = true
          this.updateDataDialog.isLoading = true
          // 加载更新数据
          let params = this.$extend({
            requestType: 'load',
            'bean.id': row.id
          }, postParams)
          this.$ajax({
            url: baseApiUrl.DataGridUrl,
            method: 'post',
            data: this.$qs.stringify(params, {
              arrayFormat: 'repeat'
            })
          }).then((response) => {
            if (response.data) {
              switch (response.data['responseCode']) {
                case 'SUCCESS': {
                  let dataItem = response.data['dataItem']
                  if (dataItem) {
                    this.updateDataDialog.form.id = row.id
                    // 处理返回数据
                    let gridUpdatableColumns = this.gridUpdatableColumns
                    if (gridUpdatableColumns) {
                      gridUpdatableColumns.forEach((column) => {
                        let propValue
                        if (column.isIgnoreEmptyWhenUpdate) {
                          propValue = ''
                        } else {
                          propValue = getValueByPath(dataItem, column.prop)
                          if (column.inputConfig) {
                            if (column.inputConfig.elementType === 'DROP_DOWN_SELECT_LIST'
                              || column.inputConfig.elementType === 'DROP_DOWN_SELECT_PAGE'
                              || column.inputConfig.elementType === 'CASCADER_SELECT') {
                              if (column.inputConfig.apiData.multiProp) {
                                propValue = propValue || []
                              }
                              // 记录引用值
                              this.updateDataDialog.form[column._prop + '_$ref'] = getValueByPath(dataItem, column.prop + '_$ref')
                              // 记录原始值
                              this.updateDataDialog.form[column._prop + '_origin'] = propValue
                            }
                          }
                        }
                        this.updateDataDialog.form[column._prop] = propValue
                      })
                      // 加载完后清除验证标记
                      this.$nextTick(() => {
                        this.clearValidate('gridUpdateDataForm')
                      })
                    }
                  } else {
                    this.$message({
                      message: '请求返回数据为空',
                      type: 'warning',
                      center: true
                    })
                  }
                  break
                }
                default: {
                  this.$message({
                    message: response.data['message'],
                    type: 'warning',
                    center: true
                  })
                  break
                }
              }
            }
          }, () => {
            this.$message.error({
              message: '数据加载失败，请稍候重试',
              center: true
            })
          }).finally(() => {
            this.$nextTick(() => {
              this.updateDataDialog.isLoading = false
            })
          })
        })
      } else {
        this.$notify({
          title: '操作错误',
          message: '内容不支持编辑修改',
          type: 'error',
          duration: 2000
        })
      }
    },
    // 提交更新数据
    submitUpdateData () {
      this.$refs['gridUpdateDataForm'].validate((valid) => {
        if (valid) {
          let postParams = this.$extend(this.$attrs)
          if (!postParams[routeConfig.DataGrid.param]) {
            return
          }
          let gridUpdatableColumns = this.gridUpdatableColumns
          if (gridUpdatableColumns) {
            let updateId = this.updateDataDialog.form.id
            if (updateId) {
              let updateParams = {
                'bean.id': updateId
              }
              gridUpdatableColumns.forEach((column) => {
                updateParams['bean.' + column.prop] = this.updateDataDialog.form[column._prop]
                // 更新下拉数据时需要提供原始值
                if (column.inputConfig) {
                  if (column.inputConfig.elementType === 'DROP_DOWN_SELECT_LIST'
                    || column.inputConfig.elementType === 'DROP_DOWN_SELECT_PAGE'
                    || column.inputConfig.elementType === 'CASCADER_SELECT') {
                    updateParams['bean.' + column.prop + '_origin'] = this.updateDataDialog.form[column._prop + '_origin']
                  }
                  if (column.inputConfig.elementType === 'IMAGE_UPLOAD' || column.inputConfig.elementType === 'FILE_UPLOAD') {
                    updateParams['bean.' + column.prop + '_filename'] = this.updateDataDialog.form[column._prop + '_filename']
                  }
                }
              })
              let params = this.$extend({
                requestType: 'update'
              }, updateParams, postParams)
              // 发送添加请求
              this.updateDataDialog.isCommitting = true
              this.$ajax({
                url: baseApiUrl.DataGridUrl,
                method: 'post',
                data: this.$qs.stringify(params, {
                  arrayFormat: 'repeat'
                })
              }).then((response) => {
                if (response.data) {
                  switch (response.data['responseCode']) {
                    case 'SUCCESS': {
                      this.$message({
                        message: response.data['message'],
                        type: 'success',
                        center: true
                      })
                      // 结果处理
                      this.updateDataDialog.isShow = false
                      this.$nextTick(() => {
                        this.triggerDataChange('update')
                        this.reloadGridData()
                      })
                      break
                    }
                    default: {
                      this.$message({
                        message: response.data['message'],
                        type: 'warning',
                        center: true
                      })
                      break
                    }
                  }
                }
              }, () => {
                this.$message.error({
                  message: '请求发送失败，请稍候重试',
                  center: true
                })
              }).finally(() => {
                this.updateDataDialog.isCommitting = false
              })
            } else {
              this.$message.error({
                message: '表格更新信息缺失',
                center: true
              })
            }
          } else {
            this.$message.error({
              message: '获取表格更新信息失败',
              center: true
            })
          }
        }
      })
    },
    // 点击删除按钮
    handleDeleteData () {
      let selectCount = this.selection.length
      if (selectCount > 0) {
        this.$confirm('此操作将删除' + (this.isSelectAll ? '全部搜索' : ' ' + selectCount + ' 条选中') + '记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.submitDeleteData()
        }).catch(() => {})
      } else {
        this.$message.error({
          message: '请选择要删除的项',
          center: true
        })
      }
    },
    // 提交删除数据
    submitDeleteData () {
      let postParams = this.$extend(this.$attrs)
      if (!postParams[routeConfig.DataGrid.param]) {
        return
      }
      let loadingInstance = Loading.service({
        target: this.$grid.$el,
        text: '请求提交中，请稍候...'
      })
      let params = this.$extend({
        requestType: 'delete',
        selection: this.selection,
        postSearch: JSON.stringify(this.getGridSearchParams()),
        selectAllSearch: this.isSelectAll
      }, postParams)
      this.$ajax({
        url: baseApiUrl.DataGridUrl,
        method: 'post',
        data: this.$qs.stringify(params, {
          arrayFormat: 'repeat'
        })
      }).then((response) => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message({
                message: response.data['message'],
                type: 'success',
                center: true
              })
              this.triggerDataChange('delete')
              this.reloadGridData()
              break
            }
            default: {
              this.$message({
                message: response.data['message'],
                type: 'warning',
                center: true
              })
              break
            }
          }
        }
      }, () => {
        this.$message.error({
          message: '请求发送失败，请稍候重试',
          center: true
        })
      }).finally(() => {
        this.$nextTick(() => {
          loadingInstance.close()
        })
      })
    },
    // 导出表格数据
    handleExportData () {
      if (this.gridData.config && this.gridData.config.exportConfig && this.gridData.config.exportConfig.length > 0) {
        this.dataExportDialog.isRender = true
        this.$nextTick(() => {
          this.dataExportDialog.isShow = true
        })
      } else {
        this.$notify({
          title: '操作错误',
          message: '内容不支持导出数据',
          type: 'error'
        })
      }
    },
    // 导出表格全选
    handleExportSelectAll () {
      this.dataExportDialog.exportProps = (this.gridExportableColumns || []).map(column => column.prop)
    },
    // 导出表格反选
    handleExportSelectReverse () {
      const exportProps = this.dataExportDialog.exportProps
      this.dataExportDialog.exportProps = (this.gridExportableColumns || [])
        .filter(column => !exportProps.includes(column.prop)).map(column => column.prop)
    },
    // 开始导出数据
    startExportData () {
      if (!this.dataExportDialog.exportType) {
        this.$message({
          message: '请选择导出格式',
          type: 'warning',
          center: true
        })
        return
      }
      if (!this.dataExportDialog.exportScope) {
        this.$message({
          message: '请选择导出范围',
          type: 'warning',
          center: true
        })
        return
      }
      switch (this.dataExportDialog.exportScope) {
        case 'selection': {
          if (this.selection.length === 0) {
            this.$message({
              message: '当前未勾选任何记录',
              type: 'warning',
              center: true
            })
            return
          }
          break
        }
        case 'current': {
          if (!this.gridData.rowList || this.gridData.rowList.length === 0) {
            this.$message({
              message: '当前页记录为空',
              type: 'warning',
              center: true
            })
            return
          }
          break
        }
        case 'all': {
          if (typeof this.gridData.totalCount === 'number' && this.gridData.totalCount === 0) {
            this.$message({
              message: '当前搜索记录为空',
              type: 'warning',
              center: true
            })
            return
          }
          break
        }
      }
      let exportColumns = []
      let gridExportableColumns = this.gridExportableColumns
      if (gridExportableColumns) {
        exportColumns = gridExportableColumns.filter(column => this.dataExportDialog.exportProps.includes(column.prop))
      }
      if (exportColumns.length === 0) {
        this.$message({
          message: '请选择要导出的字段',
          type: 'warning',
          center: true
        })
        return
      }
      let postParams = this.$extend(this.$attrs)
      if (!postParams[routeConfig.DataGrid.param]) {
        return
      }
      // 开始导出表格数据
      this.dataExportDialog.isExporting = true
      let exportParams = {
        title: this.dataExportDialog.exportTitle,
        type: this.dataExportDialog.exportType,
        scope: this.dataExportDialog.exportScope,
        line: this.dataExportDialog.exportLine,
        props: exportColumns.map(column => column.prop)
      }
      switch (this.dataExportDialog.exportScope) {
        case 'selection': {
          exportParams['selection'] = this.selection
          break
        }
        default:
          break
      }
      let params = this.$extend({
        requestType: 'export',
        exportParams: JSON.stringify(exportParams),
        searchParams: JSON.stringify(this.getGridSearchParams())
      }, postParams)
      this.$ajax({
        url: baseApiUrl.DataGridUrl,
        method: 'post',
        data: this.$qs.stringify(params, {
          arrayFormat: 'repeat'
        })
      }).then((response) => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message({
                message: response.data['message'],
                type: 'success',
                center: true
              })
              // 处理结果数据
              this.dataExportDialog.exportResult.optimizeTask = response.data['optimizeTask']
              this.dataExportDialog.exportResult.fileName = response.data['fileName']
              this.dataExportDialog.exportResult.downloadLink = response.data['downloadLink']
              this.$nextTick(() => {
                this.dataExportDialog.isShowResult = true
              })
              break
            }
            default: {
              this.$message({
                message: response.data['message'],
                type: 'warning',
                center: true
              })
              break
            }
          }
        }
      }, () => {
        this.$message.error({
          message: '请求发送失败，请稍候重试',
          center: true
        })
      }).finally(() => {
        this.dataExportDialog.isExporting = false
      })
    },
    // 打印表格数据
    handlePrintData () {
      this.dataPrintDialog.isRender = true
      this.$nextTick(() => {
        this.dataPrintDialog.isShow = true
      })
    },
    // 开始打印数据
    startPrintData () {
      this.$emit('printGridData', {
        printHeader: this.dataPrintDialog.printHeader,
        scopeType: this.dataPrintDialog.printScope,
        fieldType: this.dataPrintDialog.printField
      })
    },
    // 点击取消选择按钮
    clearSelection: function () {
      this.$emit('clearGridSelection')
    },
    // 获取菜单的类型
    getMenuActionIcon: function (menuAction) {
      let actionIcon
      if (menuAction.actionType) {
        switch (menuAction.actionType) {
          case 'ADD':
            actionIcon = 'iconfont icon-add'
            break
          case 'EDIT':
            actionIcon = 'iconfont icon-edit'
            break
          case 'DELETE':
            actionIcon = 'iconfont icon-delete'
            break
          case 'IMPORT':
            actionIcon = 'iconfont icon-import'
            break
          case 'EXPORT':
            actionIcon = 'iconfont icon-export'
            break
          case 'PRINT':
            actionIcon = 'iconfont icon-printer'
            break
          case 'MARK':
            actionIcon = 'iconfont icon-tag'
            break
          case 'VIEW':
            actionIcon = 'iconfont icon-inquire'
            break
          case 'CLOCK':
            actionIcon = 'iconfont icon-clock'
            break
          case 'GRANT':
            actionIcon = 'iconfont icon-not-pass'
            break
          case 'ACCOUNT':
            actionIcon = 'iconfont icon-account-only'
            break
          case 'TOOL':
            actionIcon = 'iconfont icon-briefcase'
            break
          default:
            actionIcon = menuAction.actionType
            break
        }
      } else {
        actionIcon = 'iconfont icon-click'
      }
      return actionIcon
    },
    // 菜单是否可用
    isMenuEnable (menuAction) {
      if (menuAction.paramType) {
        switch (menuAction.paramType) {
          case 'NONE': {
            if (this.isPreciseMode) {
              return this.selection.length === 0
            } else {
              return true
            }
          }
          case 'SINGLE':
            return this.selection.length === 1
        }
      }
      return this.selection.length > 0
    },
    // 获取参数化的地址
    getParameterPath (actionPath) {
      if (actionPath) {
        actionPath = actionPath.replace(new RegExp('\\$\\{ids\\}', 'gm'), this.selection.join(','))
        actionPath = actionPath.replace(new RegExp('\\$\\{search\\}', 'gm'),
          encodeURIComponent(JSON.stringify(this.getGridSearchParams())))
        return actionPath
      } else {
        return null
      }
    },
    // 点击菜单
    handleMenuClick (menuAction) {
      if (this.isMenuEnable(menuAction) && menuAction.handlerType) {
        // 获取请求链接
        let actionPath = menuAction.actionPath
        if (actionPath) {
          if (menuAction.paramType === 'NONE') {
            // 对参数不作要求
          } else if (menuAction.paramType === 'SINGLE') {
            if (this.selection.length !== 1) {
              this.$message({
                message: '请选择一行记录进行操作',
                type: 'warning',
                center: true
              })
              return
            }
          } else {
            if (this.selection.length === 0) {
              this.$message({
                message: '请至少选一行记录进行操作',
                type: 'warning',
                center: true
              })
              return
            } else {
              let maxHandleNum = menuAction.paramMaxLength || 200
              if (this.selection.length > maxHandleNum) {
                this.$message({
                  message: '选择的行数超过最大处理数，请最多选择' + maxHandleNum + '行记录进行处理',
                  type: 'warning',
                  center: true
                })
                return
              }
            }
          }
          switch (menuAction.handlerType) {
            case 'AJAX': {
              let confirmMsg = menuAction['confirmMsg']
              if (confirmMsg) {
                this.$confirm(confirmMsg, '操作确认', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: menuAction['confirmType'] || 'warning'
                }).then(() => {
                  this.handleAjaxRequest(menuAction, actionPath)
                }).catch(() => {})
              } else {
                this.handleAjaxRequest(menuAction, actionPath)
              }
              break
            }
            case 'ROUTE': {
              let routeUrl = this.getParameterPath(actionPath)
              let routeTargetType = menuAction['routeTargetType']
              this.$emit('changeRoutePath', routeUrl, routeTargetType)
              break
            }
            case 'LINK': {
              this.handleLinkRequest(menuAction, actionPath)
              break
            }
            case 'IMPORT': {
              this.handleImportRequest(menuAction)
              break
            }
            case 'UNPACK': {
              this.handleUnpackRequest(menuAction)
              break
            }
            case 'ASYNC': {
              this.handleAsyncRequest(menuAction)
              break
            }
            case 'POPUP': {
              this.handlePopupRequest(menuAction)
              break
            }
            case 'DRAWER': {
              this.handleDrawerRequest(menuAction)
              break
            }
            case 'BUBBLE': {
              this.handleBubbleRequest(menuAction)
              break
            }
            case 'CASCADE': {
              this.handleCascadeRequest(menuAction)
              break
            }
            default: {
              this.$message({
                message: '未知的数据请求类型',
                type: 'warning',
                center: true
              })
              break
            }
          }
        } else {
          this.$message({
            message: '请求链接信息缺失',
            type: 'warning',
            center: true
          })
        }
      }
    },
    // 获取搜索参数
    getGridSearchParams () {
      return this.$extend({
        pageIndex: this.gridData.config ? this.gridData.config.pageIndex : null,
        pageSize: this.gridData.config ? this.gridData.config.pageSize : null
      }, {
        sort: this.gridData.config ? this.gridData.config.sort : null
      }, this.gridSearch.currentParams)
    },
    // 获取预处理参数
    getPreHandleParams (menuAction) {
      let ids
      if (menuAction.paramType !== 'NONE') {
        ids = this.selection
      } else {
        ids = []
      }
      return {
        postIds: ids,
        postSearch: JSON.stringify(this.getGridSearchParams()),
        selectAllSearch: this.isSelectAll
      }
    },
    // AJAX请求
    handleAjaxRequest (menuAction, url) {
      let postParams = this.$extend(this.$attrs)
      if (!postParams[routeConfig.DataGrid.param]) {
        return
      }
      let loadingInstance = Loading.service({
        target: this.$grid.$el,
        text: '请求提交中，请稍候...'
      })
      let params = this.$extend(this.getPreHandleParams(menuAction), postParams)
      this.$ajax({
        url: url,
        method: 'post',
        data: this.$qs.stringify(params, {
          arrayFormat: 'repeat'
        })
      }).then((response) => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message({
                message: response.data['message'],
                type: 'success',
                center: true
              })
              this.$bus.$emit(`${globalEvent.templateGrid.DATA_STATE_CHANGED}:${this.$attrs[routeConfig.DataGrid.param]}`)
              this.reloadGridData()
              break
            }
            default: {
              this.$message({
                message: response.data['message'],
                type: 'warning',
                center: true
              })
              break
            }
          }
        }
      }, () => {
        this.$message.error({
          message: '请求发送失败，请稍候重试',
          center: true
        })
      }).finally(() => {
        this.$nextTick(() => {
          loadingInstance.close()
        })
      })
    },
    // LINK请求
    handleLinkRequest (menuAction, url) {
      let gridLinkForm = this.$refs['gridLinkForm']
      if (gridLinkForm) {
        let action = this.$contextPath(url)
        if (action && action.startsWith('#')) {
          // 前端跳转不传参
          this.submitFormOption.method = 'get'
          this.submitFormOption.postParams = null
        } else {
          this.submitFormOption.method = 'post'
          this.submitFormOption.postParams = this.$extend(this.getPreHandleParams(menuAction))
        }
        this.submitFormOption.action = action
        if (deviceUtils.isIOSDevice()) {
          // ios设备不支持target
          this.submitFormOption.target = ''
        } else {
          this.submitFormOption.target = menuAction['linkTargetType'] || '_blank'
        }
        // 开始提交
        this.$nextTick(() => {
          gridLinkForm.submit()
        })
      } else {
        this.$message({
          message: '请求模块信息缺失',
          type: 'warning',
          center: true
        })
      }
    },
    // 导入数据请求
    handleImportRequest (menuAction) {
      menuAction.isRenderImport = true
      this.$nextTick(() => {
        menuAction.isShowImport = true
      })
    },
    // 拆包数据请求
    handleUnpackRequest (menuAction) {
      menuAction.isRenderUnpack = true
      this.$nextTick(() => {
        menuAction.isShowUnpack = true
      })
    },
    // 异步任务请求
    handleAsyncRequest (menuAction) {
      menuAction.isRenderAsync = true
      this.$nextTick(() => {
        menuAction.isShowAsync = true
      })
    },
    // 弹出组件窗口
    handlePopupRequest (menuAction) {
      menuAction.isRenderPopup = true
      this.$nextTick(() => {
        menuAction.isShowPopup = true
      })
    },
    // 打开抽屉组件
    handleDrawerRequest (menuAction) {
      menuAction.isRenderDrawer = true
      this.$nextTick(() => {
        menuAction.isShowDrawer = true
      })
    },
    // 打开气泡组件
    handleBubbleRequest (menuAction) {
      menuAction.isShowBubble = !menuAction.isShowBubble
    },
    // 打开层叠页面组件
    handleCascadeRequest (menuAction) {
      menuAction.isRenderCascade = true
      this.$nextTick(() => {
        menuAction.isShowCascade = true
      })
    },
    // 重新加载数据
    reloadGridData () {
      this.$emit('reloadGridData')
    },
    // 数据导入成功
    dataImportSuccess () {
      this.triggerDataChange('import')
      this.reloadGridData()
    },
    // 数据拆包成功
    dataUnpackSuccess () {
      this.triggerDataChange('unpack')
      this.reloadGridData()
    },
    // 异步任务成功
    asyncTaskSuccess () {
      this.triggerDataChange('async')
      this.reloadGridData()
    },
    // 关闭弹出窗口
    hidePopup (menuAction) {
      menuAction.isShowPopup = false
    },
    // 关闭弹窗并且刷新
    hidePopupAndRefresh (menuAction) {
      menuAction.isShowPopup = false
      this.reloadGridData()
    },
    // 关闭抽屉
    hideDrawer (menuAction) {
      menuAction.isShowDrawer = false
    },
    // 关闭抽屉并且刷新
    hideDrawerAndRefresh (menuAction) {
      menuAction.isShowDrawer = false
      this.reloadGridData()
    },
    // 关闭气泡
    hideBubble (menuAction) {
      menuAction.isShowBubble = false
    },
    // 关闭气泡并且刷新
    hideBubbleAndRefresh (menuAction) {
      menuAction.isShowBubble = false
      this.reloadGridData()
    },
    // 关闭层叠页面
    hideCascade (menuAction) {
      menuAction.isShowCascade = false
    },
    // 关闭抽屉并且刷新
    hideCascadeAndRefresh (menuAction) {
      menuAction.isShowCascade = false
      this.reloadGridData()
    },
    // 重置表单
    resetForm (formName) {
      let form = this.$refs[formName]
      if (form) {
        form.resetFields()
        this.$nextTick(() => {
          this.clearValidate(formName)
        })
      }
    },
    // 清除验证标记
    clearValidate (formName) {
      let form = this.$refs[formName]
      if (form) {
        form.clearValidate()
      }
    }
  },
  created () {
    // 初始化添加信息
    if (this.gridData.config) {
      // 可添加
      if (this.gridData.config.isCanAdd) {
        let gridAddableColumns = this.gridAddableColumns
        if (gridAddableColumns) {
          gridAddableColumns.forEach((column) => {
            this.$set(this.addDataDialog.form, column._prop, '')
            if (column.inputConfig) {
              if (column.inputConfig.elementType === 'IMAGE_UPLOAD' || column.inputConfig.elementType === 'FILE_UPLOAD') {
                this.$set(this.addDataDialog.form, column._prop + '_filename', '')
              }
              if (column.inputConfig.acceptType && column.inputConfig.acceptType.type === 'NUMBER') {
                if (column.renderCell && column.renderCell.cellType && column.renderCell.cellType.type === 'rate' && column.renderCell.cellType.cell) {
                  if (typeof column.renderCell.cellType.cell.defaultValue === 'number') {
                    this.$set(this.addDataDialog.form, column._prop, column.renderCell.cellType.cell.defaultValue)
                  } else {
                    this.$set(this.addDataDialog.form, column._prop, 0)
                  }
                }
              }
            } else {
              if (column.renderCell && column.renderCell.cellType && column.renderCell.cellType.type === 'switch' && column.renderCell.cellType.cell) {
                if (column.renderCell.cellType.cell.isActive) {
                  this.$set(this.addDataDialog.form, column._prop, column.renderCell.cellType.cell.activeValue)
                } else {
                  this.$set(this.addDataDialog.form, column._prop, column.renderCell.cellType.cell.inactiveValue || false)
                }
              }
            }
          })
        }
      }
      // 可更新
      if (this.gridData.config.isCanUpdate) {
        let gridUpdatableColumns = this.gridUpdatableColumns
        if (gridUpdatableColumns) {
          gridUpdatableColumns.forEach((column) => {
            this.$set(this.updateDataDialog.form, column._prop, '')
            if (column.inputConfig) {
              if (column.inputConfig.elementType === 'IMAGE_UPLOAD' || column.inputConfig.elementType === 'FILE_UPLOAD') {
                this.$set(this.updateDataDialog.form, column._prop + '_filename', '')
              } else if (column.inputConfig.elementType === 'DROP_DOWN_SELECT_LIST'
                || column.inputConfig.elementType === 'DROP_DOWN_SELECT_PAGE'
                || column.inputConfig.elementType === 'CASCADER_SELECT') {
                this.$set(this.updateDataDialog.form, column._prop + '_origin', '')
              }
              if (column.inputConfig.acceptType && column.inputConfig.acceptType.type === 'NUMBER') {
                if (column.renderCell && column.renderCell.cellType && column.renderCell.cellType.type === 'rate' && column.renderCell.cellType.cell) {
                  this.$set(this.updateDataDialog.form, column._prop, 0)
                }
              }
            }
          })
        }
      }
      // 可导出
      let gridExportableColumns = this.gridExportableColumns
      if (gridExportableColumns) {
        gridExportableColumns.forEach((column) => {
          this.dataExportDialog.exportProps.push(column.prop)
        })
      }
      if (this.gridData.config && this.gridData.config.exportConfig && this.gridData.config.exportConfig.length > 0) {
        // 默认选择第一种类型
        this.dataExportDialog.exportType = this.gridData.config.exportConfig[0].type
      }
      // 导入功能菜单
      let gridImportMenuActions = this.gridImportMenuActions
      if (gridImportMenuActions) {
        gridImportMenuActions.forEach((menuAction) => {
          this.$set(menuAction, 'isRenderImport', false)
          this.$set(menuAction, 'isShowImport', false)
        })
      }
      // 拆包功能菜单
      let gridUnpackMenuActions = this.gridUnpackMenuActions
      if (gridUnpackMenuActions) {
        gridUnpackMenuActions.forEach((menuAction) => {
          this.$set(menuAction, 'isRenderUnpack', false)
          this.$set(menuAction, 'isShowUnpack', false)
        })
      }
      // 异步任务菜单
      let gridAsyncMenuActions = this.gridAsyncMenuActions
      if (gridAsyncMenuActions) {
        gridAsyncMenuActions.forEach((menuAction) => {
          this.$set(menuAction, 'isRenderAsync', false)
          this.$set(menuAction, 'isShowAsync', false)
        })
      }
      // 弹出组件窗口菜单
      let gridPopupMenuActions = this.gridPopupMenuActions
      if (gridPopupMenuActions) {
        gridPopupMenuActions.forEach((menuAction) => {
          this.$set(menuAction, 'isRenderPopup', false)
          this.$set(menuAction, 'isShowPopup', false)
        })
      }
      // 抽屉组件菜单
      let gridDrawerMenuActions = this.gridDrawerMenuActions
      if (gridDrawerMenuActions) {
        gridDrawerMenuActions.forEach((menuAction) => {
          this.$set(menuAction, 'isRenderDrawer', false)
          this.$set(menuAction, 'isShowDrawer', false)
        })
      }
      // 气泡组件菜单
      let gridBubbleMenuActions = this.gridBubbleMenuActions
      if (gridBubbleMenuActions) {
        gridBubbleMenuActions.forEach((menuAction) => {
          this.$set(menuAction, 'isShowBubble', false)
        })
      }
      // 层叠页面组件菜单
      let gridCascadeMenuActions = this.gridCascadeMenuActions
      if (gridCascadeMenuActions) {
        gridCascadeMenuActions.forEach((menuAction) => {
          this.$set(menuAction, 'isRenderCascade', false)
          this.$set(menuAction, 'isShowCascade', false)
        })
      }
    }
  },
  deactivated () {
    this.addDataDialog.isShow = false
    this.updateDataDialog.isShow = false
    this.dataExportDialog.isShow = false
    this.dataPrintDialog.isShow = false
    let gridImportMenuActions = this.gridImportMenuActions
    if (gridImportMenuActions) {
      gridImportMenuActions.forEach(menuAction => {
        menuAction.isShowImport = false
      })
    }
    let gridUnpackMenuActions = this.gridUnpackMenuActions
    if (gridUnpackMenuActions) {
      gridUnpackMenuActions.forEach((menuAction) => {
        menuAction.isShowUnpack = false
      })
    }
    let gridAsyncMenuActions = this.gridAsyncMenuActions
    if (gridAsyncMenuActions) {
      gridAsyncMenuActions.forEach((menuAction) => {
        menuAction.isShowAsync = false
      })
    }
    let gridPopupMenuActions = this.gridPopupMenuActions
    if (gridPopupMenuActions) {
      gridPopupMenuActions.forEach(menuAction => {
        menuAction.isShowPopup = false
      })
    }
    let gridDrawerMenuActions = this.gridDrawerMenuActions
    if (gridDrawerMenuActions) {
      gridDrawerMenuActions.forEach(menuAction => {
        menuAction.isShowDrawer = false
      })
    }
    let gridBubbleMenuActions = this.gridBubbleMenuActions
    if (gridBubbleMenuActions) {
      gridBubbleMenuActions.forEach(menuAction => {
        menuAction.isShowBubble = false
      })
    }
  },
  watch: {
    'gridData.rowSelection': function () {
      if (this.selectAll) {
        if (this.gridData.rowSelection.length !== this.gridData.rowList.length) {
          this.selectAll = false
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @use "../../../styles/color" as *;

  .data-grid-function-menu {
    &.precise-mode {
      width: 100%;
      .precise-mode-header {
        float: left;
        padding: 0 8px;
        @media screen and (max-width:767px) {
          float: right;
        }
      }
      .precise-mode-tail {
        float: right;
        padding-left: 8px;
        .el-button {
          position: relative;
          &.mode-cancel,
          &.data-print,
          &.data-export {
            height: 40px;
            line-height: 36px;
            padding: 0 5px;
            color: #303133;
            i {
              margin-right: -2px;
              transform: scale(.9);
            }
            .text-span {
              vertical-align: 2px;
            }
          }
          &+.el-button {
            margin-left: 0;
          }
        }
        .precise-mode-detail {
          margin-right: 8px;
          float: left;
        }
      }
      .precise-mode-detail {
        color: #666;
        font-size: 12px;
        line-height: 40px;
        &>.current {
          color: #f56c6c;
        }
        .el-button {
          &.select-all {
            padding-left: 4px;
            padding-right: 4px;
          }
          &.quit-select-all {
            color: #f56c6c;
          }
          i {
            vertical-align: -1px;
          }
        }
      }
    }
    .function-menu-wrap {
      display: inline-flex;
      flex-wrap: wrap;
      align-items: center;
    }
    .grid-link-form {
      display: none;
    }
  }

  .el-dialog__wrapper {
    &>.el-dialog {
      &.grid-add-data-dialog,
      &.grid-update-data-dialog {
        &>.el-dialog__body {
          min-height: 200px;
          .el-form {
            padding: 25px 25px 5px 10px;
            .el-form-item {
              margin-bottom: 20px;
              .el-form-item__label {
                font-size: 12px;
              }
              .el-form-item__content {
                .el-form-item__error {
                  padding-top: 4px;
                  transform: scale(.9) translateX(-5%);
                }
                .input-tip {
                  margin-top: 8px;
                  color: #909399;
                  font-size: 12px;
                  line-height: 100%;
                }
              }
            }
            .el-loading-mask {
              z-index: 20000;
            }
          }
        }
        &>.el-dialog__footer {
          text-align: center;
        }
      }
      &.grid-data-export-dialog,
      &.grid-data-print-dialog {
        &>.el-dialog__body {
          position: relative;
          .el-form {
            padding: 15px 30px 5px 10px;
            .el-form-item {
              margin-bottom: 10px;
              .el-form-item__label {
                font-size: 12px;
              }
              .el-form-item__content {
                .el-radio {
                  .el-radio__label {
                    display: inline-block;
                    min-width: 100px;
                    font-size: 12px;
                  }
                }
                .el-checkbox {
                  .el-checkbox__label {
                    font-size: 12px;
                  }
                }
                .export-prop-list {
                  border: 1px solid #dcdfe6;
                  background-color: #fff;
                  border-radius: 4px;
                  .el-checkbox-group {
                    padding: 4px 0;
                  }
                  .export-prop-item {
                    position: relative;
                    padding: 2px 10px;
                    line-height: 24px;
                    &:hover {
                      background-color: #ecf5ff;
                    }
                    &+.export-prop-item {
                      margin-top: 1px;
                      &:before {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: -1px;
                        right: 0;
                        height: 1px;
                        background-color: rgba(0,0,0,.02);
                      }
                    }
                    .el-checkbox {
                      display: block;
                    }
                  }
                }
                .export-prop-foot {
                  margin-top: 1px;
                  padding: 0 10px;
                  .divider {
                    margin-left: 1px;
                    margin-right: 1px;
                    color: #909399;
                  }
                }
              }
            }
          }
          .export-result {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background-color: rgba(255,255,255,.8);
            z-index: 15000;
          }
        }
        &>.el-dialog__footer {
          text-align: center;
        }
      }
    }
  }
</style>
